import { CalendarSelectorVariant } from '../../../structure';
import { CreateDecisions } from '../../types';

export const createCalendarSelectorDecisions: CreateDecisions<CalendarSelectorVariant> = ({ decisions }) => ({
    backgroundColor: {
        value: decisions.backgroundColor.semanticSecondarySubtleTransparent.primary,
        variant: {
            selected: {
                value: decisions.interactive.primary.default,
            },
            inRange: {
                value: decisions.backgroundColor.semanticSecondarySubtleTransparent.primary,
            },
        },
    },
    borderColor: {
        value: decisions.interactive.plain.contrast.default,
        variant: {
            today: {
                value: decisions.backgroundColor.surface.basic.inverse,
            },
        },
    },
    color: {
        value: decisions.textColor.font.basic.default,
        variant: {
            ghost: {
                value: decisions.textColor.font.secondary.default,
            },
            selected: {
                value: decisions.textColor.font.basic.inverse,
            },
            disabled: {
                value: decisions.textColor.font.tertiary.default,
            },
        },
    },
});
